import { memo, useCallback } from 'react';
import classNames from 'classnames';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { trackEvent } from '@surfline/web-common';
import config from 'config';
import { CLICKED_SUBSCRIBE_CTA } from 'common/constants';
import PremiumBadgeIcon from 'components/Icons/PremiumBadgeIcon';
import { SpotDetails } from 'types/spot';
import styles from './LineupCamPaywall.module.scss';

const LineupCamPaywall = ({
  backgroundImage,
  spot,
}: {
  backgroundImage: string;
  spot: SpotDetails;
}) => {
  const handleUpgradeClick = useCallback(() => {
    trackEvent(CLICKED_SUBSCRIBE_CTA, {
      location: 'Lineup Cam Paywall',
      category: 'cams & reports',
      spotId: spot?._id,
      spotName: spot?.name,
    });
  }, [spot]);

  return (
    <div
      className={classNames(styles.lineupCamPaywall, 'sl-lineup-cam-paywall')}
      data-testid="lineup-cam-paywall"
    >
      <div
        className={styles.backgroundImage}
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div className={styles.overlay} />
      <div className={styles.content}>
        <Typography variant="title2" component="p" className={styles.title}>
          Watch the surf up close.
        </Typography>
        <Typography variant="body1" component="p" className={styles.subtitle}>
          Angles tracking the lineup are now available at select spots.
        </Typography>
        <Button
          className={styles.upgradeButton}
          data-testid="lineup-cam-upgrade-button"
          href={`${config.surflineHost}/upgrade`}
          onClick={handleUpgradeClick}
          startIcon={
            <PremiumBadgeIcon ribbonFill="#424242" badgeFill="#fff" width="12px" height="14px" />
          }
          disableRipple
          disableFocusRipple
          disableTouchRipple
        >
          Upgrade
        </Button>
      </div>
    </div>
  );
};

export default memo(LineupCamPaywall);
